"use client";

import { useTheme } from "@/contexts/ThemeContext";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { ReactNode, useEffect } from "react";
import { SITE_SETTINGS_QUERYResult } from "@/sanity/types";

export function ClientLayout({
  children,
  siteSettings,
}: {
  children: ReactNode;
  siteSettings: SITE_SETTINGS_QUERYResult | null;
}) {
  const { themeColors } = useTheme();

  useEffect(() => {
    document.body.style.backgroundColor = themeColors.backgroundColor;

    // Update meta theme-color
    let metaThemeColor = document.querySelector('meta[name="theme-color"]');
    if (!metaThemeColor) {
      metaThemeColor = document.createElement("meta");
      metaThemeColor.setAttribute("name", "theme-color");
      document.head.appendChild(metaThemeColor);
    }
    metaThemeColor.setAttribute("content", themeColors.backgroundColor);
  }, [themeColors.backgroundColor]);

  return (
    <section
      className="min-h-screen"
      style={{ backgroundColor: themeColors.backgroundColor }}
    >
      <Header siteSettings={siteSettings} />
      <div className="w-full">{children}</div>
      <Footer siteSettings={siteSettings} />
    </section>
  );
}
